import { useTheme } from "styled-components";

interface IProps {
  showBorderBottom?: boolean;
  isMultiCol: boolean;
  headerText: string;
  asHTags?: boolean;
  headerLink?: string;
  LinksData: {
    linkUrl: string;
    linkText: string;
    slug?: string;
    id?: number;
    target?: string;
  }[];
  parentComponent?: string;
}

const HeadingAndLinks = ({
  headerText,
  LinksData,
  isMultiCol,
  headerLink,
  asHTags,
  parentComponent,
}: IProps) => {
  const { locale } = useTheme();
  const handleFooterOneLinks = (linkData, index, parentComponent) => {
    switch (parentComponent) {
      case "PricesAndCalculator":
        return (
          <a
            key={index}
            href={linkData.linkUrl}
            className="blackColor mb-16 width-fit"
          >
            {linkData.linkText}
          </a>
        );
      case "Others":
        if (linkData?.linkUrl) {
          return (
            <a
              key={index}
              href={linkData.linkUrl}
              className="blackColor mb-16 width-fit"
              target={linkData.target}
            >
              {linkData.linkText}
            </a>
          );
        }
        break;
      default:
        return (
          <a
            key={index}
            href={linkData.linkUrl}
            className="blackColor mb-16 width-fit"
            target={linkData.target}
          >
            {linkData.linkText}
          </a>
        );
    }
  };

  return isMultiCol ? (
    <nav>
      {asHTags && <strong className="block mb-8">{headerText}</strong>}
      <div className="flex flexDirectionColumn">
        {!asHTags &&
          LinksData.map((linkData, index) => (
            <a
              key={index}
              href={linkData.linkUrl}
              className="blackColor mb-16 width-fit"
            >
              {linkData.linkText}
            </a>
          ))}
      </div>
    </nav>
  ) : (
    <nav>
      {headerLink ? (
        <a href={`/${locale + "/"}${headerLink}`}>{headerText}</a>
      ) : (
        <h3 className="block mb-16 pb-8">{headerText}</h3>
      )}
      <div className="font-14 flex flexDirectionColumn">
        {!asHTags
          ? LinksData.map((linkData, index) =>
              handleFooterOneLinks(linkData, index, parentComponent)
            )
          : LinksData.map((linkData, index) => (
              <h3 key={index}>
                <a
                  href={linkData.linkUrl}
                  className="block font-14 blackColor mb-8"
                >
                  {linkData.linkText}
                </a>
              </h3>
            ))}
      </div>
    </nav>
  );
};

export default HeadingAndLinks;
